module.exports = __webpack_public_path__ + "static/img/icon56.257bd02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon56.png
// module id = 5uVm
// module chunks = 0